/* eslint-disable no-trailing-spaces */
/* eslint-disable eqeqeq */
/* eslint-disable @typescript-eslint/no-inferrable-types */
import { Component, OnInit } from '@angular/core';
import { NavController } from '@ionic/angular';
import { LocalStorageService } from '../services/core/local-storage.service';
import { CONFIG } from '../services/app-config.service';
import { GlobalVariable } from '../global';
import { UserApiService } from '../services/user-api.service';

@Component({
  selector: 'app-splash',
  templateUrl: './splash.page.html',
  styleUrls: ['./splash.page.scss'],
})
export class SplashPage implements OnInit {
  text = 'Loading..';
  image = 'assets/animation/loader.svg';
  colorShown = '#ffffff';
  errorScreen: boolean = false;
  constructor(
    private localStorageService: LocalStorageService,
    public server: UserApiService,

    private nav: NavController,
    public globals: GlobalVariable
  ) {
    this.getWelcomeBanners();
    this.text = CONFIG.splash_text;
    this.image = CONFIG.splash_image;
  }

  ngOnInit() {}
  
  reload() {
    location.reload();
  }
  getWelcomeBanners() {
    console.log('inweb',this.globals.inWeb);
    
    this.errorScreen = false;

    this.server.welcomeBanners().subscribe(
      (res) => {
        this.globals.welcomeTitle = res.welcome_screen_title;
        this.globals.welcomeSubtitle = res.welcome_screen_subtitle;
        this.globals.banner_image = 'url(' + res.welcome_screen_image + ')';

        setTimeout(() => {
          if (this.localStorageService.getTour('Tour') == 'true') {
            if (this.globals.inWeb) {
              this.nav.navigateRoot('/order');
            } else {
              this.nav.navigateRoot('/tabs/tabs/home');
            }
          } else {
            this.nav.navigateRoot('/slider');
          }
        }, 2000);
      },
      (err) => {
        this.errorScreen = true;
        this.globals.presentToast('Network Error!');
      }
    );
  }
}
